import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthSelectors, AuthDispatchers } from '../store';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({providedIn: 'root'})
export class AuthGuard implements CanActivate {

    constructor(
        private authSelector: AuthSelectors,
        private authDispatch: AuthDispatchers,
        private router: Router,
    ) {}

    canActivate(): Observable<boolean> {
        const isCloud = environment['authMode'] === 'cloud';
        return this.authSelector.loggedIn$.pipe(
            map((loggedIn: boolean) => {
                if (loggedIn) {
                    return true;
                }
                if (!isCloud) {
                    const token = localStorage.getItem('token');
                    if (token) {
                        this.authDispatch.autoLogin();
                        return false;
                    }
                }
                this.router.navigate(['/login']);
                return false;
            })
        );
    }
}
